import {action, observable, toJS} from 'mobx';
import {Lead} from './lead';
import {BaseStore} from '../base';
import {callLeadGetAll} from '../../helpers/api/lead';

export class LeadStore extends BaseStore {
  @observable filters = {
    phone: null,
    date: null,
  };

  @observable page = 1;
  @observable pageSize = 50;

  @observable isLoading = false;
  @observable loadError = null;
  @observable leads = [];
  @observable total = 0;


  @action async changePageAndLoad(page, pageSize){
    this.page = page;
    this.pageSize = pageSize;

    await this.load();
  }

  @action async load() {
    if (this.isLoading) {
      return ;
    }

    this.isLoading = true;
    this.loadError = null;

    const res = await callLeadGetAll({
      limit: this.pageSize,
      offset: this.pageSize * this.page - this.pageSize,
      ...toJS(this.filters)
    });

    this.isLoading = false;

    if (res) {
      this.leads = res.items.map(i => new Lead(this, i));
      this.total = res.total;
    } else {
      this.loadError = 'Не удалось загрузить список заявок';
    }
  }

  @action onLeadRemoved(lead) {
    this.leads = this.leads.filter(i => i !== lead);
  }

  @action onUpdateRead(newRead) {
    console.log('stores', this.stores)
    this.stores.crmStore.incrementRead('leads', newRead ? -1 : 1);
  }

  @action patchFilters(partialFilters) {
    this.filters = { ...toJS(this.filters), ...partialFilters };
  }

  @action resetFilters() {
    this.filters = {};
  }


}



// WEBPACK FOOTER //
// ./src/stores/lead/lead-store.js